import React, { Fragment } from "react";
import HomeText from "../Texts/HomeText";
import { Link } from "react-scroll";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowCircleDown } from "@fortawesome/free-solid-svg-icons";

export default () => {
  return (
    <Fragment>
      <HomeText />
      <Link
        activeClass="active"
        to="about"
        spy={true}
        smooth={true}
        offset={1}
        duration={750}
        className="bottom-button"
      >
        <FontAwesomeIcon icon={faArrowCircleDown} size="2x" />
      </Link>
    </Fragment>
  );
};
